import {
  CustomerGroupApiType,
  CustomerGroupsTableType,
  MembersGroupReponseApiType,
  MemberGroupApiType,
  GroupMemberFiltred,
  GroupTableType,
} from './types';

/* Rows at every depth (Réseau → communautés → sous-communautés) so the table expands them all */
export const filterApiResponse = (
  groups: Array<CustomerGroupApiType>
): CustomerGroupsTableType =>
  groups.map(group => ({
    key: group.id,
    id: group.id,
    group: filterGroup(group),
    children: group.children?.length ? filterApiResponse(group.children) : null,
  }));

const filterGroup = (group: CustomerGroupApiType): GroupTableType => ({
  id: group.id,
  name: group.name,
  description: group.description,
  code: group.code,
  avatar: group.avatar,
  cover: group.cover,
  children: group.children?.length
    ? group.children.map((child: CustomerGroupApiType) => filterGroup(child))
    : [],
  address: group.places[0]?.address?.formatted_address,
  member_count: group.member_count,
});

export const filterMembersApiResponse = (
  response: MembersGroupReponseApiType
): Array<GroupMemberFiltred> => {
  const { data } = response;

  return Object.values(data).map((member: MemberGroupApiType) => {
    return {
      key: member.source.id,
      id: member.source.id,
      memberInfo: {
        id: member.source.id,
        firstname: member.source.first_name,
        lastname: member.source.last_name,
        address: member.source.places[0]?.address?.formatted_address,
      },
    };
  });
};
